var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 1 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2443"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 373",
    cx: 4.85664,
    cy: 4.85741,
    rx: 4.85664,
    ry: 4.85741,
    transform: "matrix(0.9999 0.0141356 -0.0141311 0.9999 0.137207 1.15625)",
    fill: "#DE8901"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 368",
    cx: 4.80981,
    cy: 4.81059,
    rx: 4.80981,
    ry: 4.81059,
    transform: "matrix(0.9999 0.0141356 -0.0141311 0.9999 0.178711 0.992188)",
    fill: "url(#paint0_linear_5141_10485)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 369",
    cx: 4.19317,
    cy: 4.19384,
    rx: 4.19317,
    ry: 4.19384,
    transform: "matrix(0.9999 0.0141356 -0.0141311 0.9999 0.778809 1.625)",
    fill: "#DE8901"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 370",
    cx: 3.93201,
    cy: 3.91812,
    rx: 3.93201,
    ry: 3.91812,
    transform: "matrix(0.9999 0.0141356 -0.0141311 0.9999 1.03564 1.90234)",
    fill: "url(#paint1_linear_5141_10485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.54351 4.1884L4.54163 4.32134C4.53833 4.57676 4.64191 4.82314 4.82967 5.00649C5.01743 5.18983 5.27405 5.29517 5.54326 5.29942L5.79737 5.30301L5.77883 6.61482C5.77025 7.22163 5.52153 7.45427 4.89464 7.44982L4.83649 7.449L4.77835 7.44817C4.23338 7.40847 4.02109 7.16159 4.02912 6.59395L4.0611 4.3311C4.06273 4.20447 4.03806 4.07873 3.9885 3.96107C3.93893 3.84341 3.86543 3.73613 3.7722 3.64536C3.67898 3.55458 3.56784 3.48209 3.44515 3.43202C3.32246 3.38195 3.19061 3.35529 3.05713 3.35354L2.91699 3.35156L2.87145 6.57372C2.86481 7.04372 2.97083 7.44304 3.18733 7.76225C3.40382 8.08147 3.85298 8.48067 4.71756 8.53924L4.7175 8.54365L5.03266 8.54811L5.03272 8.54369C5.89803 8.50958 6.35295 8.13089 6.58372 7.81027C6.81449 7.48965 6.927 7.10115 6.93364 6.63115L6.96768 4.22267L4.54351 4.1884ZM3.77908 4.32711L3.74716 6.5861C3.73517 6.80415 3.77669 7.02194 3.86844 7.22233C3.74394 7.15952 3.63098 7.07799 3.53395 6.9809C3.26106 6.70117 3.13652 6.29552 3.16667 5.76737L3.16318 5.76732L3.19333 3.63411C3.36034 3.66752 3.51005 3.75488 3.61687 3.88127C3.7237 4.00766 3.78104 4.16524 3.77908 4.32711ZM6.65104 6.62715C6.64512 7.04585 6.54603 7.39095 6.35263 7.65968C6.14738 7.94425 5.72851 8.28262 4.89454 8.28021L4.86256 8.27976C4.02944 8.2586 3.61971 7.90851 3.42316 7.61827C3.29576 7.42471 3.21281 7.20789 3.17974 6.98196C3.22395 7.04655 3.27366 7.1076 3.32838 7.16449C3.68215 7.52317 4.23725 7.71033 4.97805 7.72081L4.97811 7.71639C5.70541 7.69467 6.0477 7.34308 6.05794 6.61877L6.08023 5.04106L5.54702 5.03353C5.37637 5.0309 5.21189 4.97211 5.08172 4.86721C4.95155 4.76231 4.86377 4.61781 4.83339 4.45844L6.68132 4.48456L6.65104 6.62715Z",
    fill: "url(#paint2_linear_5141_10485)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5141_10485",
    x1: 1.83509,
    y1: 0.702939,
    x2: 4.81067,
    y2: 9.62089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBE23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5141_10485",
    x1: 3.93201,
    y1: 0,
    x2: 3.93201,
    y2: 7.83625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FFA826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1CB02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5141_10485",
    x1: 4.93691,
    y1: 4.17108,
    x2: 4.87506,
    y2: 8.54588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC62"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.4c18205031b13cfce14fdccce459c8b8.svg";
export { ForwardRef as ReactComponent };